import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWorks";
import WhyAiStonks from "./components/WhyAiStonks";
import TrustSafety from "./components/TrustSafety";
import FutureFocused from "./components/FutureFocused";
import WaitlistForm from "./components/WaitlistForm";
import Footer from "./components/Footer";
import AnimatedBackground from "./components/AnimatedBackground";
import CommandShowcase from "./components/CommandShowcase";
import { Dialog, DialogContent } from "./components/ui/dialog";

const Home = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);

  const scrollToWaitlist = () => {
    const waitlistSection = document.querySelector('.waitlist-section');
    if (waitlistSection) {
      waitlistSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToHowItWorks = () => {
    const howItWorksSection = document.getElementById('how-it-works');
    if (howItWorksSection) {
      howItWorksSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="landing-page">
      <AnimatedBackground />
      <Header onWaitlistClick={() => setShowWaitlistModal(true)} />
      
      <main className="main-content">
        <HeroSection 
          onPrimaryClick={() => setShowWaitlistModal(true)}
          onSecondaryClick={scrollToHowItWorks}
        />
        <CommandShowcase />
        <HowItWorks />
        <WhyAiStonks />
        <TrustSafety />
        <FutureFocused />
        <WaitlistForm />
      </main>

      <Footer />

      <Dialog open={showWaitlistModal} onOpenChange={setShowWaitlistModal}>
        <DialogContent className="waitlist-dialog" aria-describedby="waitlist-description">
          <div style={{ display: 'none' }}>
            <h2 id="dialog-title">Join Waitlist</h2>
            <p id="waitlist-description">Sign up for early access to AiStonks</p>
          </div>
          <WaitlistForm isModal={true} onClose={() => setShowWaitlistModal(false)} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
